import {
    ADD_UNREAD_MESSAGE,
    REMOVE_UNREAD_MESSAGES,
    SET_MESSAGE_READ_DATETIME,
    SET_UNREAD_MESSAGES
} from "../mutations/chat";
import moment from 'moment';

const initialState = {
    unread_messages: [],
};

const chat = {
    namespaced: true,
    state: initialState,

    mutations: {
        [SET_UNREAD_MESSAGES](state, payload) {
            state.unread_messages = payload.messages;
        },
        [ADD_UNREAD_MESSAGE](state, payload) {
            state.unread_messages.push(payload.message);
        },
        [REMOVE_UNREAD_MESSAGES](state, payload) {
            state.unread_messages = state.unread_messages.filter((message) => {
                return !payload.ids.includes(message.id);
            });
        },
        [SET_MESSAGE_READ_DATETIME](state, payload) {
            state.unread_messages = state.unread_messages.map((message) => {
                if (payload.ids.includes(message.id)) {
                    message.data_ora_lettura = moment().format('YYYY-MM-DD HH:mm:ss');
                }
            });
        }
    },
    getters: {
        counter: (state) => {
            return state.unread_messages.length
        },
        getMsgCounterFromId: (state) => (id) => {
            try {
                let counter = 0;

                state.unread_messages.forEach((message) => {
                    if (message.id_chat === id) {
                        counter += 1;
                    }
                });

                return counter;
            } catch (e) {
                return null
            }
        }
    },
    actions: {
        setUnreadMessages({commit, state}, messages) {
            commit({
                type: SET_UNREAD_MESSAGES,
                messages,
            })
        },
        addUnreadMessage({commit, state}, message) {
            commit({
                type: ADD_UNREAD_MESSAGE,
                message
            })
        },
        removeUnreadMessages({commit, state}, ids) {
            commit({
                type: REMOVE_UNREAD_MESSAGES,
                ids
            })
        },
        setMessageReadDatetime({commit, state}, ids) {
            commit({
                type: SET_MESSAGE_READ_DATETIME,
                ids
            });
        }
    }
};

export default chat;
